import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import {
  ApplicationQrveyActions,
  ApplicationQrveyActionTypes,
} from '../_actions/application-qrvey.actions';
import { QueryParamsModel } from '../../_base/crud';
import { ApplicationQrvey } from '../_models/application-qrvey.model';

export interface ApplicationQrveyState extends EntityState<ApplicationQrvey> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedApplicationQrveyId: number;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<ApplicationQrvey> = createEntityAdapter<ApplicationQrvey>();

export const initialApplicationQrveyState: ApplicationQrveyState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedApplicationQrveyId: undefined,
  showInitWaitingMessage: true,
});

export function applicationQrveyReducer(
  state = initialApplicationQrveyState,
  action: ApplicationQrveyActions,
): ApplicationQrveyState {
  switch (action.type) {
    case ApplicationQrveyActionTypes.ApplicationQrveyPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedApplicationQrveyId: undefined,
      };
    case ApplicationQrveyActionTypes.ApplicationQrveyActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case ApplicationQrveyActionTypes.ApplicationQrveyPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case ApplicationQrveyActionTypes.ApplicationQrveyPageLoaded: {
      return adapter.addMany(action.payload.applicationQrveys, {
        ...initialApplicationQrveyState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case ApplicationQrveyActionTypes.ThrowApplicationQrveyError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case ApplicationQrveyActionTypes.FireApplicationQrveySuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getApplicationQrveyState =
  createFeatureSelector<ApplicationQrveyState>('applicationQrvey');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
